export default "__VITE_ASSET__CbqA_zOB__"